import { computed } from '@angular/core';
import { signalStoreFeature, withComputed, withState } from '@ngrx/signals';
import { errorMessage } from '@shared/utilities/error-message';

export type RequestStatus = 'idle' | 'pending' | 'fulfilled' | { error: string };
export interface RequestStatusState {
  requestStatus: RequestStatus;
}

export function withRequestStatus() {
  return signalStoreFeature(
    withState<RequestStatusState>({ requestStatus: 'idle' }),
    withComputed(({ requestStatus }) => ({
      isPending: computed(() => requestStatus() === 'pending'),
      isFulfilled: computed(() => requestStatus() === 'fulfilled'),
      error: computed(() => {
        const status = requestStatus();
        return typeof status === 'object' ? status.error : null;
      }),
    })),
  );
}

export function setPending(): RequestStatusState {
  return { requestStatus: 'pending' };
}

export function setFulfilled(): RequestStatusState {
  return { requestStatus: 'fulfilled' };
}

/**
 * A failed request. Takes whatever a `catch` hands over and keeps it as a non-empty message, so
 * `error()` is truthy whenever the request failed — also for an error with no text or no body.
 */
export function setError(error: unknown): RequestStatusState {
  return { requestStatus: { error: errorMessage(error) } };
}
